import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { HOME_COPY } from '../data/home-microempresario.content';

export type HomeCancelarModalStep = 'form' | 'confirm';

/**
 * Modal v2: cancelar solicitud (observación) + confirmación.
 */
@Component({
  selector: 'app-home-cancelar-modal',
  templateUrl: './home-cancelar-modal.component.html',
  styleUrls: ['./home-cancelar-modal.component.scss'],
  standalone: false,
})
export class HomeCancelarModalComponent implements OnChanges {
  @Input() open = false;
  @Input() step: HomeCancelarModalStep = 'form';
  @Input() idSolicitud: string | number | null = null;
  @Input() mensajeConfirmacion = '';
  @Input() confirmando = false;

  @Output() closed = new EventEmitter<void>();
  @Output() solicitarConfirmacion = new EventEmitter<string>();
  @Output() confirmar = new EventEmitter<void>();

  readonly copy = HOME_COPY.modalCancelarSolicitud;

  observacion = '';
  submitted = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']?.currentValue === true) {
      this.observacion = '';
      this.submitted = false;
    }
    if (changes['step']?.currentValue === 'form') {
      this.submitted = false;
    }
  }

  get observacionInvalida(): boolean {
    return !this.observacion.trim();
  }

  get showObservacionError(): boolean {
    return this.submitted && this.observacionInvalida;
  }

  onClose(): void {
    if (this.confirmando) {
      return;
    }
    this.closed.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  onSalirForm(): void {
    this.onClose();
  }

  onCancelarSolicitud(): void {
    this.submitted = true;
    if (this.observacionInvalida) {
      return;
    }
    this.solicitarConfirmacion.emit(this.observacion.trim());
  }

  onConfirmar(): void {
    if (this.confirmando) {
      return;
    }
    this.confirmar.emit();
  }

  onSalirConfirm(): void {
    this.onClose();
  }
}
